async function handleResponse(res) {
  let text;
  let json;

  try {
    // Always read body once
    text = await res.text();
    json = JSON.parse(text);
  } catch {
    json = null; // not JSON
  }

  if (!res.ok || (json && json.success === false)) {
    const message =
      json?.error ||
      json?.message ||
      text ||
      `Request failed with status ${res.status}`;
    throw new Error(message);
  }

  // Return useful data if available
  if (json) {
    return json.data !== undefined ? json.data : json;
  }

  // Non-JSON but still OK (rare)
  return text;
}

export async function apiGet(url) {
  const res = await fetch(url, { credentials: 'include' });
  return handleResponse(res);
}

export async function apiPost(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  return handleResponse(res);
}

export async function apiPut(url, body) {
  const res = await fetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  return handleResponse(res);
}

export async function apiPatch(url, body) {
  const res = await fetch(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  return handleResponse(res);
}


export async function apiUpload(url, formData) {
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  return handleResponse(res);
}

export async function apiDelete(url) {
  const res = await fetch(url, {
    method: 'DELETE',
    credentials: 'include',
  });
  return handleResponse(res);
}
